import React from 'react'
import styles from './StandardWidthPage.scss'
import cx from 'classnames'

export const StandardWidthPage = ({ className, ...props }) => (
  <div className={cx(styles.StandardWidthPage, className)} {...props} />
)
